import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type MarketPerformanceSubscription from 'lumen/models/market-performance/subscription';

export type MetricType = 'otb';

export interface MetricVariance {
  absolute: number;
  percent: number;
}

export interface VarianceSet {
  adr: MetricVariance;
  occupancy: MetricVariance;
  revenue: MetricVariance;
  revpar: MetricVariance;
  rooms: MetricVariance;
}

export interface MarketPerformanceTotalsItem {
  adr: number | null;
  occupancy: number | null;
  revenue: number;
  revpar: number | null;
  rooms: number;
  variance?: VarianceSet;
}

export interface MarketPerformanceMeta {
  group_by: string;
  include: MetricType[];
  page: number;
  page_size: number;
  target_currency: string;
  total_pages: number;
  total_records: number;
  totals: Record<MetricType, MarketPerformanceTotalsItem>;
  warnings: string[];
}

export default class MarketPerformanceDataItem extends Model {
  [Type] = 'market-performance/data-item' as const;

  @belongsTo('market-performance/subscription', { async: false, inverse: null })
  declare subscription: MarketPerformanceSubscription;

  @attr('number') declare adr: number | null;
  @attr('string') declare metricType: MetricType;
  @attr('string') declare month: string | null;
  @attr('number') declare occupancy: number | null;
  @attr('number') declare revenue: number;
  @attr('number') declare revpar: number | null;
  @attr('number') declare rooms: number;
  @attr() declare variance: VarianceSet | null;
}
